export default 'course';